// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"FadeIn_fadeIn__Zp7M1","passive":"FadeIn_passive__IEqxh","fade-in":"FadeIn_fade-in__jK7Un"};